import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.shareablePlaylistLinks.isLoading;
export const list$ = (state: State) => state.shareablePlaylistLinks.list;
export const isError$ = (state: State) => state.shareablePlaylistLinks.isError;
